// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3RIyJ","select":"Header_select__1m3bZ","clinic":"Header_clinic__MhXE-"};